const relativePath = require('../index');
const assert = require('assert');

const isWin = process.platform === 'win32';
describe('relative-path', function() {

  it('will convert paths to relative to cwd', function() {

    assert.equal(relativePath('/foo/bar//zar'), '/foo/bar/zar', 'should behaive the same as path.normalize 1');
    assert.equal(relativePath('foo/bar//zar'), 'foo/bar/zar', 'should behaive the same as path.normalize 2');
    assert.equal(relativePath('./foo//bar//zar'), 'foo/bar/zar', 'should behaive the same as path.normalize 3');

    if (isWin) {
      assert.equal(relativePath(process.cwd() + '/./beep/boop'), './beep/boop', 'should convert an absolute path to a relative one to cwd');
      assert.equal(relativePath(process.cwd() + '/beep/boop'), './beep/boop', 'should convert an absolute path to a relative one to cwd');
    }
  });
});
